import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import OrderService from "services/orderStatusService";
import { removeOrdersList, updateOrdersList } from "utils/OrdersUtil";
export const initialState = {
  list: [],
  fetching: false,
  updating: false,
  deleting: false,
  showMessage: false,
  showEditForm: false,
};

export const fetchOrders = createAsyncThunk(
  "/fetchOrders",
  async (data, { rejectWithValue }) => {
    try {
      const response = await OrderService.fetch(data);
      var code = response.code;
      return {
        code: code,
        Orders: response.data,
      };
    } catch (err) {
      let code = err.response?.data.code;
      let response = err.response;
      return rejectWithValue({
        code: code,
        errorMessages: response?.data?.message || "Error",
      });
    }
  }
);

export const updateOrder = createAsyncThunk(
  "/updateOrder",
  async (data, { rejectWithValue }) => {
    try {
      const response = await OrderService.update(data);
      const code = response.code;
      return {
        code: code,
        Order: response.data,
      };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Error");
    }
  }
);

export const deleteOrder = createAsyncThunk(
  "/deleteOrder",
  async (id, { rejectWithValue }) => {
    try {
      const response = await OrderService.delete(id);
      const code = response.code;
      return {
        code: code,
        Order: response.data,
      };
    } catch (err) {
      return rejectWithValue({ error: "Error deleting a Order" });
    }
  }
);

export const filterOrders = createAsyncThunk(
  "/filterOrders",
  async (data, { rejectWithValue }) => {
    try {
      const response = await OrderService.fetch(data);
      var code = response.code;
      return {
        code: code,
        orders: response.data,
      };
    } catch (err) {
      let code = err.response?.data.code;
      let response = err.response;
      return rejectWithValue({
        code: code,
        errorMessages: response?.data?.message || "Error",
      });
    }
  }
);

export const OrderSlice = createSlice({
  name: "orders",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.fetching = !state.fetching;
    },
    toggleOrderEditForm: (state) => {
      state.showEditForm = !state.showEditForm;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrders.pending, (state) => {
        state.fetching = true;
      })
      .addCase(fetchOrders.fulfilled, (state, action) => {
        state.fetching = false;
        state.list = action.payload.Orders;
      })
      .addCase(fetchOrders.rejected, (state, action) => {
        state.fetching = false;
      })
      .addCase(updateOrder.pending, (state, action) => {
        state.updating = true;
      })
      .addCase(updateOrder.fulfilled, (state, action) => {
        state.updating = false;
        // console.log(action.payload.Orders);
        state.list = updateOrdersList(state.list, action.payload.Order);
        state.showEditForm = !state.showEditForm;
      })
      .addCase(updateOrder.rejected, (state, action) => {
        state.errorMessages = action.payload;
        state.updating = false;
      })
      .addCase(deleteOrder.pending, (state, action) => {
        state.deleting = true;
      })
      .addCase(deleteOrder.fulfilled, (state, action) => {
        state.deleting = false;
        state.list = removeOrdersList(state.list, action.payload.Order);
      })
      .addCase(deleteOrder.rejected, (state, action) => {
        state.deleting = false;
      })
      .addCase(filterOrders.pending, (state) => {
        state.fetching = true;
      })
      .addCase(filterOrders.fulfilled, (state, action) => {
        state.fetching = false;
        state.list = action.payload.orders;
      })
      .addCase(filterOrders.rejected, (state, action) => {
        state.fetching = false;
      });
  },
});

export const { showLoading, toggleOrderEditForm } = OrderSlice.actions;

export default OrderSlice.reducer;
